import { render } from "./browseruserPage.vue?vue&type=template&id=d11298aa"
import script from "./browseruserPage.vue?vue&type=script&lang=js"
export * from "./browseruserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__